import React, { useState } from "react";
import { Box, makeStyles, Typography, Button, Grid } from "@material-ui/core";
import ProjectRegistrationStepOne from "../components/ProjectRegistration/ProjectRegistrationStepOne";
import ProjectRegistrationStepFour from "../components/ProjectRegistration/ProjectRegistrationStepFour";
import ProjectRegistrationStepThree from "../components/ProjectRegistration/ProjectRegistrationStepThree";
import ProjectRegistrationStepTwo from "../components/ProjectRegistration/ProjectRegistrationStepTwo";
import ProjectRegistrationStepper from "../components/ProjectRegistration/ProjectRegistrationStepper";
import ProjectRegistrationStepFive from "../components/ProjectRegistration/ProjectRegistrationStepFive";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "2.4rem",
    minHeight: "65rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: "3rem",
  },

  stepperBtnText: {
    fontWeight: "600",
    fontSize: "1.4rem",
    lineHeight: "2rem",
  },

  stepperBtn: {
    width: "14rem",
    height: "4rem",
  },

  stepperBtnOutlined: {
    width: "14rem",
    height: "4rem",
    border: "1px solid #F630A9",
    background: "#fff",
    marginRight: "3rem",
  },

  stepperBtnOutlinedText: {
    fontWeight: "600",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#F630A9",
    "&:hover": {
      color: "#fff",
    },
  },

  container: {
    padding: "2.4rem 10rem",
  },

  stepperButtonsContainer: {},
}));

const ProjectRegistration = () => {
  const classes = useStyles();
  const history = useHistory();

  const [currentStep, setCurrentStep] = useState(1);
  const [disableButton,setDisableButton]=useState(true)
  const projectData = useSelector((state) => state.ui.projectData);

  const [changeFlag, setChangeFlag] = useState(0);

  console.log("Project updated details => ", projectData);

  const onNextClick = () => {
    console.log("onNextClick", { currentStep });
    setDisableButton(true)
    if (currentStep === 1) {
      setChangeFlag(1);
    } else if (currentStep === 2) {
      setChangeFlag(2);
    } else if (currentStep === 3) {
      setChangeFlag(3);
    } else if (currentStep === 4) {
      setChangeFlag(4);
      // if (projectData) {
      // history.push("/dashboard");
      // }
    }
  };
  const maxSteps = 4;
  return (
    <Box className={classes.container}>
      <Typography className={classes.pageHeading}>
        Project Registration Form
      </Typography>

      <Grid container>
        <Grid item xs={12} md={3} lg={3}>
          <ProjectRegistrationStepper
            maxSteps={maxSteps}
            currentStep={currentStep}
          />
        </Grid>
        <Grid item xs={12} md={7} lg={7}>
          <Box className={classes.StepContainer}>
            {currentStep === 1 ? (
              <ProjectRegistrationStepOne
                setDisableButton={setDisableButton}
                changeFlag={changeFlag}
                onNextClick={() =>
                  setCurrentStep((step) => (step < maxSteps ? step + 1 : 1))
                }
              />
            ) : currentStep === 2 ? (
              <ProjectRegistrationStepTwo
              setDisableButton={setDisableButton}
                changeFlag={changeFlag}
                onNextClick={() =>
                  setCurrentStep((step) => (step < maxSteps ? step + 1 : 1))
                }
              />
            ) : currentStep === 3 ? (
              <ProjectRegistrationStepThree
              setDisableButton={setDisableButton}
                changeFlag={changeFlag}
                onNextClick={() =>
                  setCurrentStep((step) => (step < maxSteps ? step + 1 : 1))
                }
              />
            ) : currentStep === 4 ? (
              <ProjectRegistrationStepFour
              setDisableButton={setDisableButton}
                changeFlag={changeFlag}
                onNextClick={() =>
                  setCurrentStep((step) => (step < maxSteps ? step + 1 : step))
                }
              />
            ) : null}

            <Box
              display="flex"
              flexDirection="row"
              className={classes.stepperButtonsContainer}
            >
              <Button
                className={classes.stepperBtnOutlined}
                style={
                  currentStep === 1 ? { display: "none" } : { display: "block" }
                }
                // display={currentStep === 1 ? "none" : "block"}
                onClick={() => {
                  setCurrentStep((step) => (step > 1 ? step - 1 : 1));
                  setChangeFlag(0);
                }}
              >
                <Typography className={classes.stepperBtnOutlinedText}>
                  Back
                </Typography>
              </Button>
              <Button
                className={classes.stepperBtn}
                disabled={disableButton}
                // disabled={currentStep > 3}
                onClick={() => {
                  onNextClick();
                }}
              >
                <Typography className={classes.stepperBtnText}>
                  {currentStep == maxSteps ? "Submit" : "Next"}
                </Typography>
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectRegistration;
